import React from 'react';

export default ({ sections }) => (
  <div>
    { sections.map( (section, index) => {
        if(index % 2 == 0) {
            return (<div className="section">
                <div className="columns">
                    <div className="column is-6">
                        <img src={section.image} />
                    </div>
                    <div className="column is-6">
                        <h2>{section.title}</h2>
                        <p>{section.description}</p>
                    </div>
                </div>
            </div>)
        } else {
            return (
                <div className="section">
                    <div className="columns">
                        <div className="column is-6" style={{textAlign: 'right'}}>
                            <h2>{section.title}</h2>
                            <p>{section.description}</p>
                        </div>
                        <div className="column is-6">
                            
                            <img src={section.image} />
                        </div>
                    </div>
                </div>
            )
        }
    }
    )}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Sections.js